<div
  class="flex flex--column justify--center items--center"
  style="height: 80vh;"
>
  <img
    src="lantern/assets/images/pages/no-permission/403.png"
    style="height: 80px; width: auto;"
  />
  <div class="f--1 bold text--dark pt--4 pb--3">No permission</div>
  <div class="f--5 text--light">
    You do not have access to this page. Check with your administrator for
    access.
  </div>
</div>
